import { createRouter, createWebHistory } from 'vue-router'
import * as Utils from '@/assets/utils'

import LoginView from './pages/login'

const Dashboard = () => import('./pages/dashboard/index.vue')
const Admin = () => import('./pages/admin/index.vue')
const Settings = () => import('./pages/settings/index.vue')
const Banner = () => import('./pages/banner/index.vue')
const SystemLog = () => import('./pages/systemLog/index.vue')
const MoldCertList = () => import('./pages/moldCertList/index.vue')
const MoldProjectList = () => import('./pages/moldProjectList/index.vue')
const MoldProviderList = () => import('./pages/moldProviderList/index.vue')
const MoldReviewList = () => import('./pages/moldReviewList/index.vue')
const MoldDictAdmin = () => import('./pages/moldDictAdmin/index.vue')

const routes = [
  { path: '/', redirect: { name: 'dashboard' } },
  { path: '/dashboard', name: 'dashboard', component: Dashboard },
  { path: '/mold/cert/list', name: 'moldCertList', component: MoldCertList },
  { path: '/mold/project/list', name: 'moldProjectList', component: MoldProjectList, meta: { moldProjectMode: 'list' } },
  { path: '/mold/project/audit', name: 'moldProjectAudit', component: MoldProjectList, meta: { moldProjectMode: 'audit' } },
  { path: '/mold/provider/list', name: 'moldProviderList', component: MoldProviderList },
  { path: '/mold/review/list', name: 'moldReviewList', component: MoldReviewList },
  { path: '/mold/platform', redirect: '/system/settings' },
  {
    path: '/mold/moldCategory/list',
    name: 'moldMoldCategory',
    component: MoldDictAdmin,
    meta: { apiBase: '/mold/moldCategory', title: '模具分类', parentLabel: '上级分类' },
  },
  {
    path: '/mold/industryType/list',
    name: 'moldIndustryType',
    component: MoldDictAdmin,
    meta: { apiBase: '/mold/industryType', title: '行业类型', parentLabel: '上级类型' },
  },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/admin/list', name: 'admin', component: Admin },
  { path: '/system/settings', name: 'settings', component: Settings },
  { path: '/banner/list', name: 'banner', component: Banner },
  { path: '/system/log', name: 'systemLog', component: SystemLog },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const hasSessionToken = () => {
  const t = Utils.user.getToken()
  return t != null && String(t).trim() !== ''
}

const hasSessionUserInfo = () => {
  const u = Utils.user.getInfo()
  return u != null && typeof u === 'object' && Object.keys(u).length > 0
}

router.beforeEach((to, _from, next) => {
  if (to.path === '/login' || to.name === 'login') {
    next()
    return
  }
  if (!hasSessionToken() || !hasSessionUserInfo()) {
    Utils.user.logout()
    next({
      path: '/login',
      ...(to.fullPath && to.fullPath !== '/login' ? { query: { redirect: to.fullPath } } : {}),
    })
    return
  }
  next()
})

export default router
